import styled from 'styled-components';
import { GIVONIC } from '../../styles/fonts';
import { NEUTRAL_100 } from '../../styles/colors';

interface TitleContainerProps {
  'data-has-back-button': boolean;
}

export const TitleContainer = styled.div<TitleContainerProps>`
  display: flex;
  width: 80%;
  justify-content: center;
  align-items: center;
  text-align: center;
  align-self: center;
  color: black;
  font-family: ${GIVONIC.regular};
  font-size: 16px;
  margin-top: 0.18px;
`

export const ContentContainer = styled.div`
  margin: 8px 0px 0px 0px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const Container = styled.div<{ $transparent: boolean }>`
  width: 100%;
  padding: 16px 12px;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  padding-bottom: 16px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${props => props.$transparent ? 'transparent' : NEUTRAL_100};
  box-sizing: border-box;
  background-color: ${props => props.$transparent ? 'transparent' : 'white'};
`

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  position: relative;
`

export const AbsoluteContentWrapper = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
